export interface FAQItem {
    question: string;
    answer: string;
}

export interface FAQSub {
    [name: string]: FAQItem[];
}

interface IFAQState {
    faqs: FAQSub;
}

// initial state
const activityState: IFAQState = {
    faqs: {
        papyrus: [
            {
                question: 'How does Papyrus work?',
                answer: 'Papyrus allows for the issuance of digital representation of products on the blockchain, similar to the concept of non-fungible tokens (NFT). When you click Add Product , enter its details and click Finish, you are basically issuing this certificate on the blockchain.\nAs a user, you can then claim this certificate ownership through the LuxTag mobile app, and tag the physical product with NFC or QR to allow verification of products with Papyrus.',
            },
            {
                question: 'What do I need to start using Papyrus?',
                answer: 'In order to use Papyrus effectively, users would need:\n1) XEM – to fund the accounts in generating their blockchain certificate on the NEM Public Chain.\n2) NFC Tag / QR code – to tag the physical product with the digital certificate, which you can also get directly from LuxTag through our platform. Of course, this is not necessarily needed to generate the blockchain certificate.',
            },
            {
                question: 'Do I need to enter any payment details to use Papyrus Basic?',
                answer: 'No. The Papyrus Basic platform does not require any of your payment details. However, to generate a blockchain certificate you would need XEM. LuxTag will provide 10 XEM for free (non-transferable) for every validated account in Papyrus to start generating your certificate. If you haven\'t gotten your free XEM, contact us at support@luxtag.io and we will fund your account.\nYou can buy XEMs on any cryptocurrency exchanges or buy it directly from us for the market price by contacting us at customer support@luxtag.io.',
            },
            {
                question: 'What\'s the difference between a private key and a UUID?',
                answer: 'In the context of Papyrus, a private key is a one-time use QR code that allows users to claim the ownership of a particular product or asset. Once a product or asset has been claimed, the private key is no longer usable. Users who has claimed this private key owns the blockchain certificate and can transfer its ownership through the app.\nUUID is a special ID that allows users to verify and view provenance of the asset multiple times.',
            },
            {
                question: 'I’m interested to have some of Papyrus features integrated with my manufacturing and supply chain system. How do I do this?',
                answer: 'Please contact our sales team at info@luxtag.io. We’re interested to talk with you at anytime!',
            },
        ],
        nfcTags: [
            {
                question: 'Why do I need NFC tags for my product?',
                answer: 'NFC tags is the recommended method to allow the verification of your product as it provides a more seamless experience for verification & provenance viewing of your product. Alternatively, you can use QR code generated through this platform to allow the same process.',
            },
            {
                question: 'How do I order NFC tags?',
                answer: 'You can order the NFC tags by clicking the checkbox and clicking Order NFC. We will receive this order and our Customer Support will contact you directly in regards to payment.',
            },
            {
                question: 'What’s the price per NFC tags from LuxTag?',
                answer: 'The price per NFC tags will be US$1. This does not include shipping charges. (Normally we can ship this NFC tags by letters).',
            },
        ],
        xem: [
            {
                question: 'What is XEM?',
                answer: 'XEM is the native token for the NEM platform. You can learn more about NEM here, https://nem.io/',
            },
            {
                question: 'Why do I need to fund my account with XEM?',
                answer: 'The blockchain certificate is generated on a public blockchain platform called NEM. XEM is the native token for the NEM platform which acts as a ‘fuel’ to generate our certificate.',
            },
            {
                question: 'How much XEMs do I need to generate my blockchain certificate?',
                answer: 'You would need roughly 2 XEMs per blockchain certificate.',
            },
            {
                question: 'Where can I get XEM?',
                answer: 'You can get XEMs by buying it at any cryptocurrency exchange services or you can buy it directly from us by emailing us at support@luxtag.io.',
            },
            {
                question: 'How do I fund my account with XEM?',
                answer: 'After getting your XEM, you can send XEM by scanning the QRCode by using a funded NemWallet app or you can send XEM to the address stated in your account from a NemWallet app or from your cryptocurrency exchange.',
            },
            {
                question: 'Is LuxTag charging me for putting and using XEMs on this account?',
                answer: ' No, all XEMs transferred to this wallet will be funded towards this account. All charges in the creation of a blockchain certificate is paid to the NEM platform to maintain its security.',
            },
            {
                question: 'Where is my private key?',
                answer: 'You can get your private key by contacting us at support@luxtag.io.',
            },
        ],
    },
};

// getters
const getters = {
    getXem: (state: IFAQState) => state.faqs.xem,
    getPapyrus: (state: IFAQState) => state.faqs.papyrus,
    getNFCTags: (state: IFAQState) => state.faqs.nfcTags,
};

// mutations
const mutations = {
};

// actions
const actions = {
};

export default {
    state: activityState,
    getters,
    actions,
    mutations,
};
